/**
 * @file   src\Pages\UpdatePayment.tsx
 * @brief  UpdatePayment page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useEffect, useState } from '../utils/thirdpartyComponents';
import StripeUpdatePaymentCard from 'src/components/StripeUpdatePaymentCard';
import StripeProvider from 'src/StripeProvider';
import { getFromLocalStorage } from 'src/utils/helper';
import axios from "src/config/axiosConfig";
import { ProfileApi } from "src/utils/apiUrls";
import { MessageToaster } from "src/utils/toastUtil";
import SmallLoader from "src/components/SmallLoader";
import CWFooter from "src/components/CWFooter";
const UpdatePayment = () => {

    const [loading,setLoading] =  useState(true);
    const [paymentMethod,setPaymentMethod] =  useState('');
    const [paymentMethodKey,setPaymentMethodKey] =  useState('');
    const toaster = new MessageToaster();
    // initial loading
    useEffect(() => {
        fetchLocationPayment(); 
      }, []);

      const fetchLocationPayment = async () => {
        try {
         
          const responseProfile = await axios.post(ProfileApi.LOCATION_PAYMENT_METHOD);
          if (responseProfile?.data?.error === 0) {
            setPaymentMethodKey(responseProfile.data.data.publicKey.stripePublicKey)
            setPaymentMethod(responseProfile.data.data.paymentMethod)
          } else {
            toaster.toastError(responseProfile?.data?.message);
          }
        } catch (error: any) {
          throw new Error(error.response?.data?.message || error.message);
        } finally {
            setLoading(false); // Hide loader
        }
    };
    //console.log(paymentMethodKey, paymentMethod);
    return (
        <>
            {(paymentMethod === 'stripe' && paymentMethodKey) ?  
                <StripeProvider stripeKey ={paymentMethodKey}>
                    <StripeUpdatePaymentCard
                        headerText="Card Header"
                        contentText="This is the content of the card."
                        footerText="Card Footer"
                        customerId={getFromLocalStorage('CARWASH_DATA') ? getFromLocalStorage('CARWASH_DATA').userGuid : ""}
                        paymentMethod = {paymentMethod}
                    />
            </StripeProvider> : <SmallLoader/>}
            <CWFooter activeLink="Settings"/>
            {loading ? <SmallLoader/> : ''}
        </>
    )
}

export default UpdatePayment;
